export default __webpack_public_path__ + "static/media/icon_arrow_grey.e7a5cb2b.svg";